module.exports = __webpack_public_path__ + "img/mask-v2-light.1afead1a.png";